export default {
  configuration: {
    header: {
      notes: 'Header for section Configuration for hammers',
      message: 'Configuration',
    },
  },
  model: {
    deviceType: {
      notes: 'Label for Device type for a hammer',
      message: 'Device type',
      values: {
        rd3: {
          notes: 'Device type RD3 for a hammer',
          message: 'RD3',
        },
        rd_guard: {
          notes: 'Device type RD Guard (previously known as Ärdy) for a hammer',
          message: 'RD Guard',
        },
        not_connected: {
          notes:
            'No Device type selected for a hammer, meaning that it is not connected',
          message: 'Not connected',
        },
      },
    },
    communicationDeviceSerial: {
      notes:
        'Label for the serial number for the communication device for a hammer',
      message: 'Communication device serial',
      validation: {
        ardyInvalid: {
          notes:
            'Validation error when the serial number for an Ärdy device has an invalid format.',
          message: 'Invalid format for Ärdy serial number',
        },
      },
    },
    installationSide: {
      notes:
        'Label for the serial number for the communication device for a hammer',
      message: 'Installation side',
      values: {
        operator_facing: {
          notes: 'Installation orientation Carrier side for a hammer',
          message: 'Carrier side',
        },
        operator_left_hand_side: {
          notes: 'Installation orientation Left hand side for a hammer',
          message: 'Left hand side',
        },
      },
    },
  },
};
